/* eslint-disable react/no-multi-comp, react/no-danger */

import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { List } from "immutable"

import translateSelector from "common/services/intl/translateSelector"

// Some quick hack to fix cheaper option tip text (bold values in strings) - it has more complex structure
// TODO: make dynamic translate more smart (maybe use https://github.com/aknuds1/html-to-react or something similar)
const joinStringsInArr = arr =>
  arr
    .reduce((acc, el) => {
      if (
        (typeof acc.last() === "string" || typeof acc.last() === "number") &&
        (typeof el === "string" || typeof el === "number")
      ) {
        return acc.set(acc.size - 1, acc.last() + el)
      }

      return acc.push(el)
    }, List())
    .toJS()

function splitByPairTag(string, pattern, transformator) {
  const resultArray = []
  let i = 1
  string.split(pattern).forEach(part => {
    const isKey = !(i % 2)
    if (isKey) {
      resultArray.push(transformator(part))
    } else {
      resultArray.push(part)
    }
    i++
  })
  return resultArray
}

function splitBySingleTag(string, pattern, transformator) {
  const resultArray = []
  let i = 1
  string.split(pattern).forEach(part => {
    const isPattern = !(i % 2)
    if (isPattern) {
      resultArray.push(transformator(part))
    }
    resultArray.push(part)
    i++
  })
  return resultArray
}

function addStrongs(resultArray) {
  let newArray = []
  resultArray.forEach(res => {
    if (typeof res === "string") {
      newArray = newArray.concat(splitByPairTag(res, "**", part => <strong>{part}</strong>))
    } else {
      newArray.push(res)
    }
  })
  return newArray
}

function addNewLines(resultArray) {
  let newArray = []
  resultArray.forEach(res => {
    if (typeof res === "string") {
      newArray = newArray.concat(splitBySingleTag(res, "\n", () => <br />))
    } else {
      newArray.push(res)
    }
  })
  return newArray
}

function addValues(resultArray, values) {
  let newArray = []
  resultArray.forEach(res => {
    const resArray = splitByPairTag(res, "__", part => {
      if (values[part]) {
        return values[part]
      }
      console.error("translation not found: ", part) // eslint-disable-line no-console
      return part
    })
    newArray = newArray.concat(resArray)
  })
  return newArray
}

class Translate extends React.Component {
  static defaultProps = {
    className: "",
  }

  static propTypes = {
    // Basic usage
    tKey: PropTypes.string.isRequired,
    dataTest: PropTypes.string,
    values: PropTypes.object,
    className: PropTypes.string,
    // Special stuff // TODO: Explain
    translate: PropTypes.func,
    options: PropTypes.object,
    dynamic: PropTypes.bool,
  }

  shouldComponentUpdate(nextProps) {
    const { values, options, ...rest } = this.props

    if (nextProps.tKey !== rest.tKey) return true

    const valuesOk =
      !values ||
      Object.keys(values).reduce(
        (acc, key) => acc && nextProps[key] && values[key] === nextProps.values[key],
        true,
      ) // `nextProps[key]` for double safety, TODO: @oreqizer check if needed

    const optionsOk =
      !options ||
      Object.keys(options).reduce(
        (acc, key) => acc && options[key] === nextProps.options[key],
        true,
      )

    const restOk = Object.keys(rest).reduce((acc, key) => acc && rest[key] === nextProps[key], true)

    return !valuesOk || !optionsOk || !restOk
  }

  renderDynamic = () => {
    const { values = {}, tKey, translate } = this.props

    let translated = translate(tKey, {}, {}, Object.keys(values))

    // ugly hack - in translation shouldn't be html tags
    translated = translated.replace(new RegExp("<strong>", "g"), "**")
    translated = translated.replace(new RegExp("</strong>", "g"), "**")
    translated = translated.replace(new RegExp("&nbsp;", "g"), " ")

    let resultArray = [translated]
    resultArray = addValues(resultArray, values)
    resultArray = joinStringsInArr(resultArray) // rejoin array to fix strongs
    resultArray = addStrongs(resultArray)
    resultArray = addNewLines(resultArray)

    // add keys
    resultArray = resultArray.map((part, i) => {
      if (typeof part === "function") {
        return <span key={i}>{part(`${i}`)}</span>
      }
      return <span key={i}>{part}</span>
    })

    return (
      <span
        className={this.props.className}
        data-test={this.props.dataTest}
        data-tkey={this.props.tKey}
      >
        {resultArray}
      </span>
    )
  }

  render() {
    const { values, tKey, translate, options } = this.props
    if (this.props.dynamic) {
      // if dynamic param is set - use dynamic react including instead of dangerouslySetInnerHTML. TODO make it default option
      return this.renderDynamic()
    }
    return (
      <span
        className={this.props.className}
        data-test={this.props.dataTest}
        data-tkey={this.props.tKey}
        dangerouslySetInnerHTML={{ __html: translate(tKey, values, options) }}
      />
    )
  }
}

// TODO: Breaking
export const TranslateDisconnected = Translate // Expose for testing

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  translate: translateSelector(state),
}))(Translate)
